import { render, staticRenderFns } from "./tab_io_detail_gr.vue?vue&type=template&id=2dd9afb3&scoped=true"
import script from "./tab_io_detail_gr.vue?vue&type=script&lang=js"
export * from "./tab_io_detail_gr.vue?vue&type=script&lang=js"
import style0 from "./tab_io_detail_gr.vue?vue&type=style&index=0&id=2dd9afb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9afb3",
  null
  
)

export default component.exports